import React from 'react';
import { View } from 'react-native';

import { ColorProp } from '@lib/types';
import { makeStyles } from '@providers/Theme';
import { Icon, IconName } from '@components/Icon';

type UserDetailsRowProps = {
  icon: IconName;
  iconProps?: IconProps;
  value: React.ReactNode;
  details?: React.ReactNode;
};

type IconProps = {
  size?: number;
  color?: ColorProp;
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(1),
  },
  icon: {
    width: 20,
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  value: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  details: {
    paddingLeft: 20,
    width: '100%',
  },
  row: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
}));

export const UserDetailsRow: React.FC<UserDetailsRowProps> = ({
  icon,
  iconProps,
  value,
  details,
}) => {
  const styles = useStyles();

  return (
    <View style={styles.root}>
      <View style={styles.row}>
        <View style={styles.icon}>
          <Icon name={icon} size={14} {...iconProps} />
        </View>
        <View style={styles.value}>{value}</View>
      </View>

      {details && (
        <View style={styles.row}>
          <View style={styles.details}>{details}</View>
        </View>
      )}
    </View>
  );
};
